export function formatUnionTagValueCheck(check) {
  return `record tag ${JSON.stringify(check.tag)} value must be valid; actual = ${JSON.stringify(check.actual)}, allowed = ${JSON.stringify(check.allowed)}`;
}
